import React, {useState} from "react";
import {ChevronRightIcon, ChevronDownIcon} from "@heroicons/react/24/solid";

const Collapsible = ({ title, defaultOpen = false, children, classNames = '' }) => {

  // state
  const [open, setOpen] = useState(defaultOpen);

  // utilities
  const Icon = open ? ChevronDownIcon : ChevronRightIcon;

  return <>
    <div
      className={`flex gap-2 cursor-pointer ${classNames}`}
      onClick={() => { setOpen((prev) => !prev) }}
    >
      <Icon className="w-3" />
      <span>{title}</span>
    </div>
    <div className={`border-l-2 pl-3 ml-1 mb-2 py-1.5 ${!open || !children ? "hidden" : ""}`}>
      {children}
    </div>
  </>
}

export default Collapsible;